import { Env } from '@/Env';

export class CalendarMeetingLinkFreeConsultUrlLink {
  static get ENGLISH(): string {
    return Env.nodeEnv().VITE_APP_FREE_CONSULT_ENGLISH_URL;
  }

  static get QUEBEC_ENGLISH(): string {
    return Env.nodeEnv().VITE_APP_FREE_CONSULT_QUEBEC_ENGLISH_URL;
  }

  static get QUEBEC_FRENCH(): string {
    return Env.nodeEnv().VITE_APP_FREE_CONSULT_QUEBEC_FRENCH_URL;
  }
}
